var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateHint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0870fd",
    d: "M5.8,10.82a1,1,0,0,0-.69-1A1,1,0,0,0,3.86,10L1.34,12.53c-.11.12-.23.23-.23.35a1,1,0,0,0,0,.91c.12.12.12.23.23.35l2.52,2.51a1,1,0,0,0,1.25.23,1.11,1.11,0,0,0,.69-1V14.48H7.28a7.17,7.17,0,0,0,7.2-7.15V5.78h1.37a1,1,0,0,0,1-.69,1,1,0,0,0-.23-1.26L14.14,1.32c-.11-.12-.23-.23-.34-.23a1.22,1.22,0,0,0-.92,0c-.11.11-.23.11-.34.23L10,3.83a1.08,1.08,0,0,0-.35.8.72.72,0,0,0,.12.46,1.11,1.11,0,0,0,1,.69H12.2V7.27a4.88,4.88,0,0,1-4.84,4.92H5.8Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateHint);
export default __webpack_public_path__ + "static/media/rotate-hint.084ae671.svg";
export { ForwardRef as ReactComponent };